/** Стиль-пак «product-premium» — свой кусок каталога (WEB-2534: браузер покупателя грузит только пак своей воронки). */
import type { StylePack } from '../stylePack.types';

export const pack: StylePack = {
  id: 'product-premium',
  shape: {
    radiusCard: 16, radiusOption: 9, radiusButton: 'pill', radiusImage: 16,
    borderWidth: 0, borderTone: 'none', selectionMode: 'border', shadow: 'none',
  },
  density: { optionHeight: 53, optionPadY: 14, optionPadX: 16, gap: 12, contentMaxWidth: 520, screenPadX: 20 },
  type: {
    headingFamily: 'serif', h1Size: 48, h1Weight: 700, h1Tracking: -0.6,
    qSize: 32, qWeight: 700, qTracking: 0, optionSize: 16, optionWeight: 400,
    headingAlign: 'left', overlineTransform: 'uppercase',
  },
  chrome: { progress: 'bar', progressLabel: 'none', counter: false, backButton: 'icon-bare', logo: 'center' },
  cta: { placement: 'inline', fullWidth: true, height: 52, disabledStyle: 'grey' },
  states: { selected: 'filled', hoverTint: true, transitionMs: 200, screenFadeMs: 0 },
  imagery: {
    optionCard: 'label-below', overlayTone: 'none', frame: 'rounded',
    promptHint: 'product hero shot in a warm gradient scene, studio light, shallow depth of field',
  },
  // ColonBroom: товар занимает верх кадра, огромная антиква и цена — внизу
  // слева (type.headingAlign 'left'). Нижний градиент не прячет сам товар,
  // ровная вуаль спрятала бы.
  layout: { alignY: 'bottom', alignX: 'left', backgroundOverlay: 'scrim-bottom' },
  // ColonBroom: товарная воронка перед офером — стадии «подбираем состав»,
  // процент и полоса бейджей доверия, как на промо-странице.
  loader: {
    style: 'all-stages', showPercent: true, socialProof: 'laurels',
    answersSummary: false, engagementModals: true,
  },
  // ColonBroom: товарная промо-страница — моно-отсчёт в промо-полосе,
  // перфорированный тикет со скидкой, помесячная цена, чип на стыке
  // карточек-наборов с гаснущими соседями, sticky-CTA и повтор покупки внизу.
  paywall: {
    timer: 'mono-header', promoTicket: 'perforated', priceMode: 'per-month',
    planHighlight: 'chip-on-seam', dimUnselectedPlans: true,
    stickyHeader: true, repeatPurchaseBlock: true,
  },
  // Золотая кнопка пака = язык премиальности; зелёный остаётся деньгам
  // (скидка, гарантия возврата).
  accents: { money: 'success', premium: 'accent' },
};
